import { RSAA, RSAAction } from 'redux-api-middleware';

import { CreateBlockadePayload } from './blockades.types';
import * as types from './blockadesActionTypes';

export const fetchBlockades = (): RSAAction<string, string, string> => ({
  [RSAA]: {
    endpoint: '/endpoint-blockades',
    method: 'GET',
    types: [types.FETCH_BLOCKADES_REQUEST, types.FETCH_BLOCKADES_SUCCESS, types.FETCH_BLOCKADES_FAILURE],
  },
});

export const createBlockade = (body: CreateBlockadePayload): RSAAction<string, string, string> => ({
  [RSAA]: {
    body,
    endpoint: `/banks/${body.bankId}/endpoint-blockades`,
    method: 'POST',
    types: [types.CREATE_BLOCKADE_REQUEST, types.CREATE_BLOCKADE_SUCCESS, types.CREATE_BLOCKADE_FAILURE],
  },
});

export const deleteBlockade = (blockadeId: string): RSAAction<string, string, string> => ({
  [RSAA]: {
    endpoint: `/endpoint-blockades/${blockadeId}`,
    method: 'DELETE',
    types: [types.DELETE_BLOCKADE_REQUEST, types.DELETE_BLOCKADE_SUCCESS, types.DELETE_BLOCKADE_FAILURE],
  },
});
